export default {
  title: {
    id: 'bo_seller.kyb.business_details.title',
    defaultMessage: 'Business Details',
  },
  description: {
    id: 'bo_seller.kyb.business_details.description',
    defaultMessage:
      'Get verified to receive payouts by filling out this form. Double-check the details as you go. Any typos or inaccuracies could cause delays.',
  },
  legalName: {
    id: 'bo_seller.kyb.business_details.legal_name',
    defaultMessage: 'Legal business name',
  },
  email: {
    id: 'bo_seller.kyb.business_details.email',
    defaultMessage: 'Email',
  },
  tradeName: {
    id: 'bo_seller.kyb.business_details.trade_name',
    defaultMessage: 'Trade business name',
  },
  kanjiLegalCompanyName: {
    id: 'bo_seller.kyb.business_details.kanji_legal_company_name',
    defaultMessage: 'Legal business name (Kanji)',
  },
  kanaLegalName: {
    id: 'bo_seller.kyb.business_details.kana_legal_company_name',
    defaultMessage: 'Legal business name (Kana)',
  },
  latinLegalName: {
    id: 'bo_seller.kyb.business_details.latin_legal_company_name',
    defaultMessage: 'Legal business name (Latin)',
  },
  secondhandDealerNumberTitle: {
    id: 'bo_seller.kyb.business_details.secondhand_dealer_number_title',
    defaultMessage: 'Second hand dealer information',
  },
  countryOfRegistration: {
    id: 'bo_seller.kyb.business_details.country_of_registration',
    defaultMessage: 'Country of registration',
  },
  secondhandDealerNumber: {
    id: 'bo_seller.kyb.business_details.secondhand_dealer_number',
    defaultMessage: 'Secondhand dealer number',
  },
  selectFile: {
    id: 'bo_seller.kyb.business_details.select_file',
    defaultMessage: 'Select file',
  },
  registrationType: {
    id: 'bo_seller.kyb.business_details.registration_type',
    defaultMessage: 'Registration type',
  },
  registrationNumber: {
    id: 'bo_seller.kyb.business_details.registration_number',
    defaultMessage: 'Employer Identification Number (EIN)',
  },
  incorporationDate: {
    id: 'bo_seller.kyb.business_details.incorporation_date',
    defaultMessage: 'Incorporation date',
  },
  headquartersAddress: {
    id: 'bo_seller.kyb.business_details.headquarters_address',
    defaultMessage: 'Headquarters address',
  },
  branchAddress: {
    id: 'bo_seller.kyb.business_details.branch_address',
    defaultMessage: 'Branch address',
  },
  registeredBusinessAddress: {
    id: 'bo_seller.kyb.business_details.registered_business_address',
    defaultMessage: 'Registered business address (optional)',
  },
  articleOfIncorporation: {
    id: 'bo_seller.kyb.business_details.article_of_incorporation',
    defaultMessage: 'Article of incorporation',
  },
  w9FormTitle: {
    id: 'bo_seller.kyb.business_details.w9_form',
    defaultMessage: 'W-9 Form',
  },
  proofOfSecondHandDealerTitle: {
    id: 'bo_seller.kyb.business_details.proof_of_second_hand_dealer_title',
    defaultMessage: 'Proof of Second-hand Dealer Licence',
  },
  proofOfSecondHandDealerDescription: {
    id: 'bo_seller.kyb.business_details.proof_of_second_hand_dealer_description',
    defaultMessage:
      'Upload a copy of your Second-hand Dealer Licence or an official document issued by the local Public Safety Commission that shows your licence number and matches your registered business name.',
  },
  investedCapital: {
    id: 'bo_seller.kyb.business_details.invested_capital',
    defaultMessage: 'Capital invested at incorporation',
  },
  investedCapitalCurrency: {
    id: 'bo_seller.kyb.business_details.invested_capital_currency',
    defaultMessage: 'Currency',
  },
  investedCapitalAmount: {
    id: 'bo_seller.kyb.business_details.invested_capital_amount',
    defaultMessage: 'Amount',
  },
  articleOfIncorporationDescription: {
    id: 'bo_seller.kyb.business_details.article_of_incorporation_description',
    defaultMessage: 'This provides proof of business registration.',
  },
  fileUploadDescription: {
    id: 'bo_seller.kyb.business_details.article_of_incorporation_input_description',
    defaultMessage:
      'Accepted formats: PDF, JPG, JPEG, and PNG. Maximum file size: 5MB.',
  },
  saveButton: {
    id: 'bo_seller.kyb.business_details.save_button',
    defaultMessage: 'Save',
  },
  addBranch: {
    id: 'bo_seller.kyb.business_details.add_branch',
    defaultMessage: 'Add branch',
  },
  removeBranch: {
    id: 'bo_seller.kyb.business_details.remove',
    defaultMessage: 'Remove',
  },
  required: {
    id: 'bo_seller.kyb.business_details.required',
    defaultMessage: 'This field is required',
  },
  legalNameRequired: {
    id: 'bo_seller.kyb.business_details.legal_name_required',
    defaultMessage: 'Enter legal business name',
  },
  legalNameMaxLength: {
    id: 'bo_seller.kyb.business_details.legal_name_max_length',
    defaultMessage: 'Legal business name must be 80 characters or less',
  },
  legalNameInvalidCharacters: {
    id: 'bo_seller.kyb.business_details.legal_name_invalid_characters',
    defaultMessage:
      'Legal business name can only contain letters, numbers, spaces, hyphens, and periods',
  },
  tradeNameRequired: {
    id: 'bo_seller.kyb.business_details.trade_name_required',
    defaultMessage: 'Enter trade business name',
  },
  tradeNameMaxLength: {
    id: 'bo_seller.kyb.business_details.trade_name_max_length',
    defaultMessage: 'Trade business name must be 80 characters or less',
  },
  tradeNameInvalidCharacters: {
    id: 'bo_seller.kyb.business_details.trade_name_invalid_characters',
    defaultMessage:
      'Trade business name can only contain letters, numbers, spaces, hyphens, and periods',
  },
  countryOfRegistrationRequired: {
    id: 'bo_seller.kyb.business_details.country_of_registration_required',
    defaultMessage: 'Select country of registration',
  },
  registrationTypeRequired: {
    id: 'bo_seller.kyb.business_details.registration_type_required',
    defaultMessage: 'Select registration type',
  },
  registrationNumberRequired: {
    id: 'bo_seller.kyb.business_details.registration_number_required',
    defaultMessage: 'Enter registration number',
  },
  registrationNumberMaxLength: {
    id: 'bo_seller.kyb.business_details.registration_number_max_length',
    defaultMessage: 'Registration number must be 50 characters or less',
  },
  registrationNumberInvalidCharacters: {
    id: 'bo_seller.kyb.business_details.registration_number_invalid_characters',
    defaultMessage:
      'Registration number can only contain letters, numbers, spaces, parentheses, plus, minus, and periods',
  },
  incorporationDateRequired: {
    id: 'bo_seller.kyb.business_details.incorporation_date_required',
    defaultMessage: 'Select incorporation date',
  },
  headquartersAddressStreetRequired: {
    id: 'bo_seller.kyb.business_details.headquarters_address_street_required',
    defaultMessage: 'Enter street address',
  },
  headquartersAddressCityRequired: {
    id: 'bo_seller.kyb.business_details.headquarters_address_city_required',
    defaultMessage: 'Enter city',
  },
  headquartersAddressPostalCodeRequired: {
    id: 'bo_seller.kyb.business_details.headquarters_address_postal_code_required',
    defaultMessage: 'Enter postal code',
  },
  headquartersAddressCountryRequired: {
    id: 'bo_seller.kyb.business_details.headquarters_address_country_required',
    defaultMessage: 'Select country',
  },
  investedCapitalMinValue: {
    id: 'bo_seller.kyb.business_details.invested_capital_min_value',
    defaultMessage: 'Amount must be greater than 0',
  },
  maxFileSizeExceeded: {
    id: 'bo_seller.kyb.business_details.max_file_size_exceeded',
    defaultMessage: 'File size exceeds maximum allowed',
  },
  wrongFileExtension: {
    id: 'bo_seller.kyb.business_details.wrong_file_extension',
    defaultMessage: 'File type not allowed',
  },
  organizationType: {
    id: 'bo_seller.kyb.business_details.organization_type',
    defaultMessage: 'Organization type',
  },
} as const
